import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { FloatingButton } from './style';

const WhatsAppFloat = () => {
  const phoneNumber = '+6287797100842'; // Replace with your WhatsApp number
  const message = 'Halo Sequoia!'; // Optional default message

  return (
    <FloatingButton
      href={`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`}
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FaWhatsapp />
    </FloatingButton>
  );
};

export default WhatsAppFloat;